module.exports = __webpack_public_path__ + "img/rdf-icon-neon-blue.ddb616fd.png";